export default "__VITE_ASSET__1dced984__"